import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import {
  LOCAL_STORAGE_KEY,
  getValueFromStorageByKey,
} from "@/utils/localStorage";
import _isEmpty from "lodash/isEmpty";

const checkLogin = () => {
  if (_isEmpty(getValueFromStorageByKey(LOCAL_STORAGE_KEY.ACCESS_TOKEN))) {
    return false;
  }
  return true;
};

const state = {
  isLogin: checkLogin(),
  danhSachDonViVaChucVu: {},
  danhSachQuyen: [],
  nhiemVuCaNhanTabIndex: 0,
  listDonViNgoai: [],
  listDonViTrong: [],
  listCanBo: [],
  listLoaiVanBan: [],
  listDoKhan: [],
  listLuongKyDuyet: [],
  multiDonViTrong: [],
  multiDonViNgoai: [],
  multiCanBo: [],
  multiNguoiDung: [],
  allSoDen: [],
  allSoDi: [],
  allSoDenTraCuu: [],
  danhSachCanBo: {},
  thongTinUser: {},
  danhSachDonViTrongIgnore: {},
  danhSachDonViNgoaiIgnore: {},
  isLoading: false,
  danhSachCanBoVanThu: [],
  danhSachDonViTrongNgoai: [],
  scanStatus: false,
  danhSachCotHienThi : [],
  isReloadList: true,
  infFilterTraCuu: {},
  isIframe: getValueFromStorageByKey('isIframe') || false,
};
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
